import { render, staticRenderFns } from "./SetupHome.vue?vue&type=template&id=7971f84d"
import script from "./SetupHome.vue?vue&type=script&lang=js"
export * from "./SetupHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports